import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { ModuleItem } from '../../../models/module-item';
import { ModuleItemsConfig } from '../../../models/module-items-config';
import { AuthErrorResponse } from '../../../models/auth-error-response';
import { UploadIds } from '../../../models/upload';
import { ModuleItemImport } from '../../../models/module-item-import';

export const setSelectedModuleItems = createAction(
  '[Module Item] Set Selected Module Items',
  props<{ moduleItems: ModuleItem[] }>()
);

export const getModuleItemsConfig = createAction('[Module Item] Get Module Items Config');

export const getModuleItemsConfigSuccess = createAction(
  '[Module Item] Get Module Items Config Success',
  props<{ moduleItemsConfig: ModuleItemsConfig }>()
);

export const getModuleItemsConfigError = createAction(
  '[Module Item] Get Module Items Config Error',
  props<{ err: AuthErrorResponse }>()
);

export const createModuleItem = createAction(
  '[Module Item] Create Module Item',
  props<{ studyId: number; moduleId: number; moduleItem: ModuleItem }>()
);

export const createModuleItemSuccess = createAction(
  '[Module Item] Create Module Item Success',
  props<{ newModuleItem: ModuleItem; studyId: number }>()
);

export const createModuleItemError = createAction(
  '[Module Item] Create Module Item Error',
  props<{ err: HttpErrorResponse }>()
);

export const updateModuleItem = createAction(
  '[Module Item] Update Module Item',
  props<{ studyId: number; moduleId: number; moduleItem: ModuleItem }>()
);

export const updateModuleItemSuccess = createAction(
  '[Module Item] Update Module Item Success',
  props<{ updatedModuleItem: ModuleItem; studyId: number }>()
);

export const updateModuleItemError = createAction(
  '[Module Item] Update Module Item Error',
  props<{ err: HttpErrorResponse }>()
);

export const deleteModuleItem = createAction(
  '[Module Item] Delete Module Item',
  props<{ studyId: number; moduleId: number; moduleItemId: number }>()
);

export const deleteModuleItemSuccess = createAction(
  '[Module Item] Delete Module Item Success',
  props<{ studyId: number; moduleId: number; deletedModuleItemId: number }>()
);

export const deleteModuleItemError = createAction(
  '[Module Item] Delete Module Item Error',
  props<{ err: HttpErrorResponse }>()
);

export const saveModuleItemSortingOrder = createAction(
  '[Module Item] Save Module Item Sorting Order',
  props<{ studyId: number; moduleId: number; sortingOrder: number[] }>()
);

export const saveModuleItemSortingOrderSuccess = createAction(
  '[Module Item] Save Module Item Sorting Order Success',
  props<{ studyId: number; moduleId: number; sortingOrder: number[] }>()
);

export const saveModuleItemSortingOrderError = createAction(
  '[Module Item] Save Module Item Sorting Order Error',
  props<{ err: HttpErrorResponse }>()
);

export const importModuleItems = createAction(
  '[Module Item] Import Module Items',
  props<{ moduleFile: File; idsForUpload: UploadIds }>()
);

export const importModuleItemsSuccess = createAction(
  '[Module Item] Import Module Items Success',
  props<{ importedModuleItems: ModuleItemImport }>()
);

export const importModuleItemsError = createAction(
  '[Module Item] Import Module Items Error',
  props<{ err: HttpErrorResponse }>()
);
